"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _RetailPriceChartContainer = _interopRequireDefault(require("../../../RetailPriceChart/RetailPriceChartContainer"));
var _InstrumentTableContainer = _interopRequireDefault(require("../../../InstrumentTable/InstrumentTableContainer"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
require("./BuySellChartOverviewComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var chartOverviewClasses = (0, _cssClassesHelper.getBEMClasses)('chart-overview');
var BuySellChartOverviewComponent = function BuySellChartOverviewComponent(props) {
  var product1 = props.product1,
    product2 = props.product2;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('chart-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('instrument-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('instrument-container-text')
  }, product1, /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('icon-container')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowNext"
  })), product2)), /*#__PURE__*/_react["default"].createElement(_RetailPriceChartContainer["default"], {
    customClass: "chart-overview"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: chartOverviewClasses('instrument-table')
  }, /*#__PURE__*/_react["default"].createElement(_InstrumentTableContainer["default"], {
    customClass: "chart-overview-instrument"
  })));
};
var _default = exports["default"] = BuySellChartOverviewComponent;